<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row">
        <div class="page__item">
          <h1 class="title">Эдо</h1>
        </div>
      </div>
    </section>

    <section>
      <TableFilter
        :tabs="tabsFilter"
        @setActiveTab="(tab, i) => (activeTabIndex = i)"
        :propActiveTabIndex="activeTabIndex"
        style="margin-top: 32px"
        :loading="tabLoading"
      />
    </section>

    <section class="section page__content">
      <div class="page__row page__row_between mb-40">
        <div class="page__row">
          <div class="page__item page__search">
            <SearchForm
              :value="searchValue"
              @form-submit="val => (searchValue = val)"
            />
          </div>
        </div>
        <div class="page__item" style="margin-left: 16px;width: 100%">
          <div class="page__row">
            <div class="page__item" v-if="false">
              <AppButtonSmRemove
                title="Удалить"
                @click.stop.native="() => {}"
              />
            </div>

            <CustomFilter v-else style="margin-right: 16px" right="-80px">
              <b>Настройка</b>
            </CustomFilter>

            <div style="margin-left:auto">
              <AppButtonSmAdd title="Создать" @click.stop.native="() => {}" />
            </div>
          </div>
        </div>
      </div>
      <div class="data__view-controls">
        <button :class="{ active: isTableView }" @click="dataViewType = 'table'">
          <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 1L5 0.999999" stroke="#1170B8" stroke-width="2"/>
            <path d="M0 1L2 1" stroke="#1170B8" stroke-width="2"/>
            <path d="M17 6L5 6" stroke="#1170B8" stroke-width="2"/>
            <path d="M17 11L5 11" stroke="#1170B8" stroke-width="2"/>
            <path d="M0 6L2 6" stroke="#1170B8" stroke-width="2"/>
            <path d="M0 11L2 11" stroke="#1170B8" stroke-width="2"/>
          </svg>

          Список
        </button>
        <button :class="{ active: !isTableView }" @click="dataViewType = 'cards'">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="2" height="2" stroke="#95A4C0" stroke-width="2"/>
            <rect x="1" y="8" width="2" height="2" stroke="#95A4C0" stroke-width="2"/>
            <rect x="8" y="1" width="2" height="2" stroke="#95A4C0" stroke-width="2"/>
            <rect x="8" y="8" width="2" height="2" stroke="#95A4C0" stroke-width="2"/>
          </svg>

          Карточки
        </button>
      </div>
    </section>

    <section class="page__row mb-20" style="padding-bottom:21px">
      <AppTable
        v-if="isTableView"
        :data="edoList"
        :loading="false"
        :headers="tableHeaders"
        :has-checkbox="true"
        isSpecial
        :isMenuControlsActive="false"
        @toggle-active-item="() => {}"
        @toggle-active-all="isAllTableElemActive = !isAllTableElemActive"
        @edit-this-item="() => {}"
        @show-this-item="() => {}"
      />
      <div class="page__cards" v-else>
        <EdoCard
          v-for="(card, i) in edoCardList"
          :key="i + 'card'"
          :title="card.title"
          :name="card.name"
          :createdDate="card.createdDate"
          :status="card.status"
          :filesCount="card.files.length"
          :author="currentUserData"
        />
      </div>
    </section>

    <section class="section page__footer user-list__footer">
      <div class="page__row" v-if="true">
        <ThePagePagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          :lastPage="pagination.lastPage"
          @toggle-page-list="togglePaginList"
          @prev-page="() => {}"
          @next-page="() => {}"
          @get-page="() => {}"
        />
      </div>
    </section>
  </main>
</template>

<script>
import TableFilter from '@/components/page/table/TableFilter'
import SearchForm from '@/components/page/input/SearchForm'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import CustomFilter from '@/components/page/modal/CustomFilter'
import AppTable from '@/components/page/table/AppTable'
import ThePagePagination from '@/components/page/ThePagePagination'
import EdoCard from '@/components/edo/EdoCard.vue'

const tabs = [
  // { name: 'Все', count: 20, id: 1, value: '' },
  { name: 'Входящие', count: 12, id: 2, value: '' },
  { name: 'Отправленные', count: 1, id: 3, value: '' },
  // { name: 'Подписанно', count: 12, id: 4, value: '' },
  // { name: 'Согласованно', count: 12, id: 4, value: '' },
  // { name: 'Просрочено', count: 12, id: 4, value: '' },
  { name: 'Наблюдаю', count: 12, id: 5, value: '' }
]

// заглушка
const pagesExapmle = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export default {
  name: 'EdoReestrList',
  components: {
    TableFilter,
    SearchForm,
    AppButtonSmRemove,
    CustomFilter,
    AppButtonSmAdd,
    AppTable,
    ThePagePagination,
    EdoCard
  },
  data () {
    return {
      tabsFilter: tabs,
      activeTabIndex: 0,
      tabLoading: false,
      searchValue: '',
      dataViewType: 'table',
      tableHeaders: [
        {
          title: 'Дата создания',
          isSortable: false
        },
        {
          title: 'Наименование',
          isSortable: false
        },
        {
          title: 'Автор',
          isSortable: false
        },
        {
          title: 'Тип документа',
          isSortable: false
        },
        {
          title: 'Вложение',
          isSortable: false
        },
        {
          title: 'Статус',
          isSortable: false
        },
        {
          title: 'От кого',
          isSortable: false
        }
      ],
      isAllTableElemActive: false,

      // Заглушки, будет приходить один список и надо его парсить в зависимости от dataViewType
      edoList: new Array(20).fill({
        isActive: false,
        values: [
          { data: '22.01.2022' },
          { data: 'Наименование' },
          { data: 'Петр Петров' },
          { data: 'Телефонограмма' },
          { data: 'Документ.PDF' },
          { data: { name: 'На согласовании', color: 'red' }, mod: 'colorText' },
          { data: 'Петр Петров' }
        ]
      }),
      edoCardList: new Array(8).fill({
        title: 'Служебная записка',
        name: 'Наименование тестовая записка',
        createdDate: '20.02.2020, 11:00',
        status: 'На согласовании',
        files: new Array(8).fill({})
      }),

      pagination: {
        currentPage: 2,
        lastPage: pagesExapmle.at(-1),
        pageList: {
          active: false,
          pages: pagesExapmle
        }
      }
    }
  },
  computed: {
    isTableView () {
      return this.dataViewType === 'table'
    },

    // заглушка для автора
    currentUserData () {
      return this.$store.getters.currentUserData
    }
  },
  methods: {
    togglePaginList () {
      this.$set(
        this.pagination.pageList,
        'active',
        !this.pagination.pageList.active
      )
    }
  },
  watch: {
    isAllTableElemActive (val) {
      this.edoList = this.edoList.map(item => ({
        ...item,
        isActive: val
      }))
    }
  },
  destroyed () {
    this.isAllTableElemActive = false
  }
}
</script>

<style lang="scss" scoped>
.page__cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 20px;
}

.filter {
  margin-bottom: 0;
}

.data__view-controls {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  column-gap: 20px;
  margin-bottom: -9px;

  button {
    display: flex;
    align-items: center;
    column-gap: 6px;
    cursor: pointer;
    color: #95A4C0;
    transition: .3s;

    svg {
      path,rect {
        stroke: #95A4C0;
        transition: .3s;
      }
    }

    &.active {
      color:#1170B8;

      svg {
        path,rect {
          stroke: #1170B8;

        }
      }
    }
  }
}
</style>
